import { zodResolver } from '@hookform/resolvers/zod';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { Button } from 'components/Button';
import { Code } from 'components/Code';
import { FormProvider, useForm } from 'react-hook-form';
import { useState } from 'react';
import { GameSkinSchema, type GameSkin } from 'shared/modelTypes/skin';

import { SkinForm } from 'forms/GameSkinForm';
import { emitMessage } from 'engine/api';
import { toast } from 'sonner';
import { X } from 'lucide-react';
import { FilePickerProvider } from 'components/FilePickerProvider';

export const Route = createFileRoute('/dashboard/skins/new')({
	component: RouteComponent,
	loader: async () => {
		return {
			directory: (await emitMessage({ kind: 'media-list-directory', folderId: null })).media,
		};
	},
});

function RouteComponent() {
	const data = Route.useLoaderData();
	return (
		<div>
			<FilePickerProvider startDirectory={data.directory!}>
				<SkinNewForm />
			</FilePickerProvider>
		</div>
	);
}

function SkinNewForm() {
	const router = useRouter();

	const methods = useForm<GameSkin>({
		// @ts-expect-error zodResolver type inference seems to be bad
		resolver: zodResolver(GameSkinSchema),
		defaultValues: GameSkinSchema.parse({}),
	});

	const err = methods.formState.errors;

	const [result, setResult] = useState<GameSkin | undefined>();
	const [_res, setRes] = useState<Promise<unknown> | undefined>();

	// const onSubmit = (data: GameTask) => {
	// 	setResult(data);
	// };

	const onSubmit = async (data: GameSkin) => {
		setResult(data);

		const r = emitMessage({ kind: 'skin-create', skin: data });
		setRes(r);
		const response = await r;
		if (response.success) {
			router.invalidate();
			router.navigate({ to: '/dashboard/skins' });
		} else {
			setRes(undefined);
			toast('server did not save game', { icon: <X /> });
		}
	};

	console.log(err);

	return (
		<FormProvider {...methods}>
			<form
				className="flex flex-col gap-3"
				// @ts-expect-error zodResolver type inference seems to be bad
				onSubmit={methods.handleSubmit(onSubmit)}
			>
				<SkinForm label="New Skin" />
				<Button type="submit">Save skin</Button>
			</form>
			{result && (
				<Code block className="mt-4">
					{JSON.stringify(result, null, 2)}
				</Code>
			)}
		</FormProvider>
	);
}
